import { render, staticRenderFns } from "./GestionDesarchivo.vue?vue&type=template&id=cb97dac2&"
import script from "./GestionDesarchivo.vue?vue&type=script&lang=js&"
export * from "./GestionDesarchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports